module.exports = __webpack_public_path__ + "img/banner-carolina.6a9e719c.png";